import React from 'react'
import RenderProfilePicture from '../../../_helpers/profile-picture'

import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import { Card, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Sidebar({ licensed, client }) {

  if (!licensed) {
    return null
  }

  return (
    <Card className='telehealth__card p-3 text-center'>
      <Row className='mb-2'>
        <Col>
          <RenderProfilePicture
            circle
            image={licensed.profileUrl}
            cached={false}
            width={60}
            height={60}
            className='m-auto'
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h5>
            {licensed.name
              ? licensed.name
              : `${licensed.firstName} ${licensed.lastName}`}
          </h5>
        </Col>
      </Row>
      <Row className='sub__text my-auto'>
        <Col>
          <FontAwesomeIcon
            icon={faBuilding}
            style={{ fontSize: '10px', color: '#AFAFAF' }}
          />
          &nbsp;
          {client.name}
        </Col>
      </Row>
    </Card>
  )
}
